<template>
  <div>
    <success-fade-alert ref="successFadeAlert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    <b-row v-if="sharedFill.sharedFillGuid">
      <b-col md="8">
        <b-form-group
          label-for="sharedLink"
          label="Link de compartilhamento"
          class="mb-4"
        >
          <div class="d-flex align-items-center position-relative">
            <b-form-input
              id="sharedLink"
              type="text"
              v-model="sharedLink"
              readonly
              class="pr-5"
            ></b-form-input>
            <b-button
              v-b-tooltip.hover.bottom
              title="Copiar"
              @click="copySharedLink"
              size="sm"
              class="position-absolute top-50 translate-middle-y right-1"
              :disabled="!exist"
            >
              <img
                src="/img/copy-icon.svg"
                alt=""
                style="width: 15px; height: 15px;"
              />
            </b-button>
          </div>
          <span v-if="!exist" style="color: red; font-size: 12px;"
            >Atenção! Este link permanece inválido até a confirmação da
            criação</span
          >
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-if="!sharedFill.sharedFillGuid">
        <b-form-group
          label="Deseja criar link de compartilhamento?"
          label-for="sharedFill"
          class="mb-4"
        >
          <b-button @click="createSharedLink" size="sm" class="mb-4"
            >Criar Link</b-button
          >
        </b-form-group>
      </b-col>
      <b-col md="4" v-if="sharedFill.sharedFillGuid">
        <b-form-group
          label-for="sharedFillType"
          label="Tipo de preenchimento"
          class="mb-4"
        >
          <b-form-select
            id="sharedFillType"
            :options="sharedFillOptions"
            v-model="sharedFill.sharedFillType"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="4" v-if="sharedFill.sharedFillGuid">
        <b-form-group
          label="Possuí data de expiração?"
          label-for="selectExpiration"
        >
          <b-form-select
            id="selectExpiration"
            v-model="selectedExpiration"
            :options="hasExpirationDate"
            class="mb-4"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col
        md="4"
        v-if="sharedFill.sharedFillGuid && selectedExpiration === 1"
      >
        <b-form-group
          label-for="sharedFillExpiration"
          label="Data de expiração"
          class="mb-4"
        >
          <b-form-input
            id="sharedFillExpiration"
            type="date"
            v-model="sharedFill.sharedFillExpiration"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="4" v-if="exist">
        <b-form-group label-for="sharedFillActive" label="Status" class="mb-4">
          <b-form-select
            id="status"
            :options="activeOptions"
            v-model="sharedFill.active"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col></b-col>
      <b-col></b-col>
      <b-col cols="6" class="text-right">
        <b-button
          v-if="!exist"
          style="margin-right: 1%;"
          size="sm"
          variant="green"
          :disabled="isRequestPending || !sharedLink || submitted"
          @click="create"
          >Confirmar</b-button
        >
        <b-button
          v-else
          style="margin-right: 1%;"
          size="sm"
          variant="green"
          :disabled="
            isRequestPending || !sharedFill.sharedFillGuid || submitted
          "
          @click="saveEditions"
          >Atualizar</b-button
        >
        <b-button
          size="sm"
          variant="danger"
          :disabled="submitted"
          @click="cancel"
          >Cancelar</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue")
  },
  props: {
    item: Object
  },
  name: "ShareModal",
  data() {
    return {
      isVisible: false,
      hasExpirationDate: [
        { value: 0, text: "Não" },
        { value: 1, text: "Sim" }
      ],
      activeOptions: [
        { value: false, text: "Inativo" },
        { value: true, text: "Ativo" }
      ],
      sharedFillOptions: [
        { value: 0, text: "Único" },
        { value: 1, text: "Múltiplo" }
      ],
      selectedExpiration: 0,
      form: {},
      sharedFill: {
        formId: 0,
        sharedFillGuid: "",
        sharedFillExpiration: null,
        sharedFillType: 0,
        active: true
      },
      sharedLink: "",
      submitted: false,
      isRequestPending: true,
      exist: false,
      alert: {
        error: "",
        success: ""
      }
    };
  },

  mounted() {
    this.loadData();
  },
  methods: {
    async createSharedLink() {
      this.sharedFill.sharedFillGuid = this.generateUUID();
      this.sharedLink = `${window.location.origin}/checklist/shared/fill/${this.sharedFill.sharedFillGuid}`;
    },
    copySharedLink() {
      navigator.clipboard
        .writeText(this.sharedLink)
        .then(() => {
          this.alert.success = "Link copiado!";
          this.$refs.successFadeAlert.show();
        })
        .catch(err => {
          this.alert.error = "Erro ao copiar o link";
          this.$refs.fadeAlertDanger.show();
          console.error("Failed to copy: ", err);
        });
    },
    async loadData() {
      this.$apiChecklist
        .get("/form/GetSharedFillByFormId/" + this.item.id.toString())
        .then(response => {
          if (response.data.data == null) {
            // this.alert.error = response.data.title;
            // this.$refs.fadeAlertDanger.show();
            this.isRequestPending = false;
            this.submitted = false;
          } else {
            this.sharedFill = response.data.data;
            this.sharedLink = `${window.location.origin}/checklist/shared/fill/${this.sharedFill.sharedFillGuid}`;
            if (this.sharedFill.sharedFillExpiration) {
              let dateParts = this.sharedFill.sharedFillExpiration
                .split("T")[0]
                .split("-");
              if (dateParts.length === 3) {
                this.sharedFill.sharedFillExpiration = `${dateParts[0]}-${dateParts[1]}-${dateParts[2]}`;
              }

              this.selectedExpiration = 1;
            }
            this.exist = true;
            this.$forceUpdate();
            this.isRequestPending = false;
          }
        })
        .catch(error => {
          this.form = {};
          if (error.response.status == 400) {
            this.alert.error = error.response.data.errors;
            this.$refs.fadeAlertDanger.show();
          }
        });
    },
    create() {
      this.sharedFill.formId = this.item.id;
      if (this.selectedExpiration == 0) {
        this.sharedFill.sharedFillExpiration = null;
      }
      this.submitted = true;
      this.$apiChecklist
        .post("/form/CreateSharedFill", this.sharedFill)
        .then(response => {
          if (response.data.data == null) {
            this.alert.error = response.data.title;
            this.$refs.fadeAlertDanger.show();
          } else if (response.data.status == 2997) {
            this.alert.error = response.data.title;
            this.$refs.fadeAlertDanger.show();
          } else {
            this.form = response.data.data;
            this.alert.success = "Link criado com sucesso!";
            this.$refs.successFadeAlert.show();
            this.exist = true;
          }
          this.submitted = false;
        })
        .catch(error => {
          this.submitted = false;

          if (error.response) {
            if (error.response.status == 400) {
              this.alert.error = "Verifique os dados informados";
              this.$refs.fadeAlertDanger.show();
            } else {
              this.alert.error = `${error.response.status} - ${error.response.statusText}`;
              this.$refs.fadeAlertDanger.show();
            }
          } else {
            this.alert.error = error.message;
            this.$refs.fadeAlertDanger.show();
          }
        });
    },
    saveEditions() {
      this.submitted = true;
      this.$apiChecklist
        .post("/form/EditSharedFill", this.sharedFill)
        .then(response => {
          if (response.data.data == null) {
            this.alert.error = response.data.title;
            this.$refs.fadeAlertDanger.show();
          } else {
            this.form = response.data.data;
            this.alert.success =
              "Configurações do link modificadas com sucesso!";
            this.$refs.successFadeAlert.show();
          }
          this.submitted = false;
        })
        .catch(error => {
          this.submitted = false;

          if (error.response) {
            if (error.response.status == 400) {
              this.alert.error = error.response.data.errors;
              this.$refs.fadeAlertDanger.show();
            } else {
              this.alert.error = `${error.response.status} - ${error.response.statusText}`;
              this.$refs.fadeAlertDanger.show();
            }
          } else {
            this.alert.error = error.message;
            this.$refs.fadeAlertDanger.show();
          }
        });
    },
    cancel() {
      this.$emit("close-modal");
    }
  }
};
</script>
